<template>

  <div>
    <div
      v-if="paymethods && paymethods.length"
      class="mb-3"
      :class="{'box-loading': loading}">
      <BillingCredcardItem
        v-for="(item, index) in paymethods"
        :key="index"
        :value="item" />
    </div>
    <button
      v-if="!openForm"
      class="btn btn-outline-primary"
      @click="showForm = true">Novo cartão de crédito</button>
    <div v-if="openForm">
      <BillingCredcardNew
        @save="saveCredcard"
        @cancel="showForm = false"
        :showCancel="hasPaymethods" />
    </div>
  </div>

</template>

<script>
import BillingCredcardItem from './BillingCredcardItem'
import BillingCredcardNew from './BillingCredcardNew'
export default {
  name: 'BillingCredcard',
  components: {
    BillingCredcardItem,
    BillingCredcardNew
  },
  props: {
    isSteps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    paymethods () {
      return this.billingResume.paymethods
    },
    hasPaymethods () {
      return this.paymethods && Array.isArray(this.paymethods) && this.paymethods.length >= 1
    },
    openForm () {
      return this.showForm || !this.hasPaymethods
    }
  },
  created () {
  },
  methods: {
    saveCredcard (data) {
      this.loading = true

      this.$store.dispatch('createBillingPaymethod', {
        description: data.description,
        token: data.token,
        set_as_default: data.set_as_default
      }).then(res => {
        this.loading = false
        this.showForm = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingCredcard.vue